/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tools_SubtitleInputs */

const en_home_tools_subtitle = /** @type {(inputs: Home_Tools_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to read, transform, and validate JSON.
Every tool runs 100% on your device.`)
};

const ko_home_tools_subtitle = /** @type {(inputs: Home_Tools_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 읽고, 변환하고, 검증하는 데 필요한 모든 것.
모든 도구가 100% 기기에서 실행됩니다.`)
};

const ja_home_tools_subtitle = /** @type {(inputs: Home_Tools_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON を読み、変換し、検証するために必要なすべて。
すべてのツールが端末上で100%動作します。`)
};

/**
* | output |
* | --- |
* | "Everything you need to read, transform, and validate JSON. Every tool runs 100% on your device." |
*
* @param {Home_Tools_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_tools_subtitle = /** @type {((inputs?: Home_Tools_SubtitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tools_SubtitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_tools_subtitle(inputs)
	if (locale === "ko") return ko_home_tools_subtitle(inputs)
	return ja_home_tools_subtitle(inputs)
});